
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 3h-2.84V1a1 1 0 00-1-1H6.84a1 1 0 00-1 1v2H3a1 1 0 00-1 1v3.57a1 1 0 001 1h.86l1.23 6.91 1.36 7.68a1 1 0 001 .83h9.14a1 1 0 001-.83l1.36-7.68 1.22-6.91H21a1 1 0 001-1V4a1 1 0 00-1-1zM7.84 2h8.32v1H7.84zM4 6.57V5h16v1.57zM15.74 22H8.28l-1-5.71h9.49zm1.36-7.71H6.91l-1-5.71h12.2z"}})])
          )
        }
      }
    